import { Panel } from "primereact/panel";
import { useState } from "react";
import { Form } from "../../common/Form";
import { CommonDialog } from "../../common/CommonDialog";
import { useTranslation } from "react-i18next";

export function TempSettings({settings,onChange})
{
    const {t}=useTranslation();
    const paperTypes=[
        {label:t('@PaperType.A4'),value:'A4'},
        {label:t('@PaperType.A3'),value:'A3'},
        {label:t('@PaperType.A5'),value:'A5'},
        {label:t('@PaperType.B4'),value:'B4'},
        {label:t('@PaperType.B5'),value:'A5'},
        {label:t('@PaperType.Letter'),value:'Letter'}
    ];
    const orientationOptions=[
        {label:t('@Orientation.Portrait'),value:'Portrait'},
        {label:t('@Orientation.Landscape'),value:'Landscape'}
    ];
    const [ts,setTs]=useState(settings);

    var parts=['pretext','posttext','sectPretext','sectPosttext'];
    var partNames=parts.map(p=>t('TempPart.'+p));

    var partFields=[];
    parts.forEach((part,index)=>{
        partFields.push({id:part,ftype:"checkbox",field:part,label:partNames[index]});
        partFields.push({id:part+'Break',ftype:"checkbox",field:part+'Break',label:t("Page_break_after_text"),disabled:!ts[part]});
        partFields.push({id:part+'Full',ftype:"checkbox",field:part+'Full',label:t("Full_width"),disabled:!ts[part]});
    });
    const onValChange=(data)=>{
        setTs(data);
        onChange(data);
    }
    return(
        <>
            <div className="flex flex-column gap-3">
            <Form id="tempSettings" formData={ts} columns="2" onChange={onValChange}
                fields={[
                {id:"pageSize",ftype:"dropdown",field:"pageSize",label:t("Paper_Type"),options:paperTypes,optionLabel:"label",optionValue:"value"},
                {id:"orientation",ftype:"dropdown",field:"orientation",label:t("Orientation"),options:orientationOptions,optionLabel:"label",optionValue:"value"}
            ]}/>
            <Panel header={t("Margins")}>
                <Form id="margins" formData={ts} columns="2" onChange={onValChange} fields={[
                    {id:"leftMargin",ftype:"number",field:"leftMargin",label:t("Left")},
                    {id:"rightMargin",ftype:"number",field:"rightMargin",label:t("Right")},
                    {id:"topMargin",ftype:"number",field:"topMargin",label:t("Top")},
                    {id:"bottomMargin",ftype:"number",field:"bottomMargin",label:t("Bottom")}                
                    ]}>
                </Form>
            </Panel>
            <Form id="columnSettings" formData={ts} columns="2" onChange={onValChange}
                fields={[
                {id:"columns",ftype:"number",field:"columns",label:t("Columns")},
                {id:"columnGap",ftype:"number",field:"columnGap",label:t("Column_Separation")}
            ]}/>
            <Form id="parts" formData={ts} columns="3" onChange={onValChange}
                fields={partFields}/>
            </div>
        </>
    )
}
export function TempSettingsDialog({visible,settings,onOK,onCancel})
{
    const {t}=useTranslation();    
    const [ts,setTs]=useState(settings);
    const _onOK=()=>{onOK(ts)};
    const _onCancel=()=>{onCancel()};
    const onChange=(ts)=>{setTs(ts)};

    return(
        <>
            <CommonDialog header={t("Settings")} visible={visible} onOK={_onOK} onCancel={_onCancel}>
                <div style={{width:'600px',height:'460px'}}>
                    <TempSettings settings={settings} onChange={onChange}></TempSettings>
                </div>
            </CommonDialog>
        </>
    )
}
